<template>
  <b-row>
    <b-col md="12">
      <component-header
        title="Resource Setup"
        @search-query="(val) => (filter = val)"
        :hasClear="false"
        @create-press="$router.push({ path: '/setup/Resources/addCurrency' })"
        @reload-data="getCurrencySetupList"
        createButtonText="Add Resource"
        :isLoading="loading"
      />
    </b-col>
    <b-col md="12">
      <b-card class="custome-card">
        <div>
          <b-table
            :dark="false"
            :hover="true"
            :striped="false"
            :bordered="true"
            :small="false"
            :fixed="false"
            responsive="sm"
            :items="isCurrencyList"
            :fields="currencySetupView"
            :current-page="currentPage"
            :per-page="perPage"
            thead-class="header"
            @filtered="onFilter"
            :filter="filter"
            show-empty
            :busy="loading"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
          >
            <template slot="updatedAt" slot-scope="data">
              <div>{{ data.item.updatedAt | formatedate }}</div>
            </template>
            <template slot-scope="data" slot="action">
              <div class="d-flex">
                <div>
                  <b-button
                    size="sm"
                    class="mr-2 button-circle"
                    variant="primary"
                    @click="currencyViewDetail(data.item)"
                  >
                    <i class="fas fa-eye"></i>
                  </b-button>
                </div>
                <div>
                  <b-button
                    size="sm"
                    class="mr-2 button-circle"
                    style="background: #fe7b08; border: #fe7b08;"Coupon Code
                    variant="primary"
                    @click="editCurrency(data.item)"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </b-button>
                </div>
                <div>
                  <b-button
                    size="sm"
                    class="mr-2 button-circle"
                    variant="danger"
                    @click="deleteCurrencylist(data.item)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </b-button>
                </div>
              </div>
            </template>
            <template slot="empty">
              <div v-if="loading" class="text-center">
                <span><b>Loading...</b></span>
              </div>
              <div v-else class="text-center">No data available.</div>
            </template>
          </b-table>
        </div>
        <div class="float-right" v-if="isCurrencyList.length > perPage">
          <b-pagination
            v-model="currentPage"
            :per-page="perPage"
            :total-rows="filterCount"
            aria-controls="my-table"
            prev-text="Prev"
            next-text="Next"
            hide-goto-end-buttons
          ></b-pagination>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from "vuex";
import loader from "@/components/loader/nipigeloader.vue";
import moment from "moment";
import ComponentHeader from "@/components/componentNewHeader/index.vue";
export default {
  name: "Resources",
  components: {
    ComponentHeader,
    loader,
  },
  data() {
    return {
      filterCount: 0,
      filter: "",
      loading: false,
      perPage: 10,
      currentPage: 1,
      hover: true,
      striped: false,
      bordered: true,
      small: false,
      fixed: false,
      dark: false,
      sortBy: "updatedAt",
      sortDesc: true,
      currencySetupView: [
        {
          key: "code",
          label: "Resource",
        },
        {
          key: "isCurrency",
          label: "Type",
        },
        {
          key: "symbol",
          label: "Symbol",
        },
        {
          key: "name",
          label: "Name",
        },
        {
          key: "updatedAt",
          label: "Last Updated",
        },
        {
          key: "action",
          label: "Action",
          thStyle: { width: "8%" },
        },
      ],
    };
  },
  computed: {
    ...mapState({
      fetchCurrencyList: (state) => state.currency.fetchCurrencyList,
    }),
    isCurrencyList() {
      let arrayObj = [];
      this.fetchCurrencyList.map((obj) => {
        if (obj.isCurrency === true) {
          obj.isCurrency = "Currency";
        } else {
          obj.isCurrency = "Non - Currency";
        }
        arrayObj.push(obj);
      });
      return arrayObj;
    },
  },
  methods: {
    async getCurrencySetupList() {
      this.loading = true;
      try {
        await this.$store.dispatch("currency/fetchCurrencySetupList");
      } catch (error) {
        this.$toasted.error("Unable to fetch data");
      } finally {
        this.loading = false;
      }
    },
    onFilter(list) {
      this.filterCount = list.length;
      this.currentPage = 1;
    },
    async deleteCurrencylist(data) {
      this.$swal({
        title: "Delete this Currency?",
        text: "Are you sure? This will be Remove?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Delete it!",
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          this.$store
            .dispatch("currency/currencyDeleteAction", data._id)
            .then((result) => {
              this.$swal({
                type: "success",
                title: "Success",
                text: "Currency Deleted Successfully!",
              });
              this.$store.dispatch("currency/fetchCurrencySetupList");
              this.loading = false;
            });
        }
      });
    },
    async currencyViewDetail(data) {
      this.$router.push({
        name: "currencyViewDetail",
        params: { id: data._id },
      });
    },
    async editCurrency(data) {
      this.$router.push({
        name: "editCurrency",
        params: { id: data._id },
      });
    },
  },
  filters: {
    formatedate: function (value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY hh:mm A");
      }
    },
  },

  async mounted() {
    this.getCurrencySetupList();
  },
};
</script>
<style scoped></style>
